import {
	Attachment,
	ObjectAvailability,
	Store,
	Translations,
	UUID,
} from '@/types/types';
import { QueryKey } from '@/configs/queryKeys';
import { Asset } from './AssetApi';
import { ProductModuleCollection } from './ProductModuleCollectionApi';
import { PriceGroup } from './PriceGroupApi';
import EntityApi, { BaseEntity } from './EntityApi';

export enum ProductModuleType {
	LINE = 'LINE',
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
	ACCESSORY = 'ACCESSORY',
}

export interface ProductModuleStoreConfiguration {
	store: Store;
	name: string;
	description: string;
	dimensions: string;
	listOrder: number;
	price: number;
	taxRate: number;
	status: ObjectAvailability;
	additionalCollections: ProductModuleCollection[];
	productModulePriceGroups: ProductModulePriceGroup[];
}

export interface ProductModulePriceGroup extends BaseEntity {
	priceGroup: PriceGroup;
	price: number;
}

export interface ProductModule extends BaseEntity {
	code: string;
	image?: Attachment;
	productModuleCollection: ProductModuleCollection;
	asset: Asset;
	listOrder: number;
	moduleType: ProductModuleType;
	productModulePriceGroups: ProductModulePriceGroup[];
	modulesBlacklistIds: UUID[];
	modulesWhitelistIds: UUID[];
	hasValuesOverride: boolean;
	attributeValueOverridesIds: UUID[];
	storeConfiguration: ProductModuleStoreConfiguration;
	storeConfigurations: ProductModuleStoreConfiguration[];
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class ProductModuleApi extends EntityApi<ProductModule> {
	constructor() {
		super(QueryKey.productModules);
	}
}

export default new ProductModuleApi();
